class ServiceModel {
  name = null;
  constructor(data) {
    if (data !== undefined) {
      this.name = data.name;
    }
  }
}

export default ServiceModel;
